import React from "react";
import {Node} from '../../nodes/Node';

export const Infotext = ({property}) => {
    let value = property.get();
    debugger;
    if (value instanceof Node) {
        value = value.getName();
    }
    return (
        <span>{value}</span>
    );
}

